import { queriesPayees } from "@query";
import { WSFlexBox, WSIcon, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";

import { selectorPayeeDisplayName } from "../../../shared/selectors/selectorPayeeDisplayName";
import { useXWingspanPayerId } from "../../Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

type Props = {
  payeeId: string;
};

export const LablePayeeName: React.FC<Props> = props => {
  const xWingspanAccount = useXWingspanPayerId();
  const queryPayee = queriesPayees.getPayee.useQuery({
    payeeId: props.payeeId,
    xWingspanAccount
  });

  const name = useMemo(() => {
    if (!queryPayee.data) {
      return;
    }

    return selectorPayeeDisplayName(queryPayee.data);
  }, [queryPayee.data]);

  if (!name) {
    return null;
  }

  return (
    <WSFlexBox alignItems="center" gap="XS" wrap="nowrap">
      <WSIcon color="gray600" name="user" size="S" />
      <WSText.ParagraphXs color="gray600">{name}</WSText.ParagraphXs>
    </WSFlexBox>
  );
};
